<template>
	<Card :dis-hover="true">
		<Tabs v-model="pageType" :animated="false" :capture-focus="true">
			<TabPane label="总监" name="inspector">
				<RoleInspectorList v-if="pageType === 'inspector'" />
			</TabPane>
			<TabPane label="客户经理项目人" name="cusMgrLeader">
				<RoleCusMgrLeaderList v-if="pageType === 'cusMgrLeader'" />
			</TabPane>
		</Tabs>
	</Card>
</template>

<script>
import RoleInspectorList from './../../system-management/project-management/role-inspector-list';
import RoleCusMgrLeaderList from './../../system-management/project-management/role-cusMgrLeader-list';

export default {
    name: 'RoleListPage',
    components: {
        RoleInspectorList,
        RoleCusMgrLeaderList
    },
    data() {
        return {
            pageType: "inspector"
        };
    },
    mounted() {},
    methods: {}
};
</script>

<style scoped>
</style>
